module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaign_TargetTitle")))]), _vm._v(" "), _c('AdvancedSearch', {
    attrs: {
      "searchCriterias": _vm.searchCriterias,
      "searchButtonLabel": "Label_Apply"
    },
    on: {
      "search": _vm.triggerListUpdate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message message--info"
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "line-height": "53px"
    }
  }, [_vm._v(_vm._s(_vm.pagination.totalCount) + " " + _vm._s(_vm.L.localize('Campaign_TargetCount')))]), _vm._v(" "), (_vm.members.length > 0) ? _c('button', {
    staticClass: "button button--border button--right",
    staticStyle: {
      "margin": "0"
    },
    on: {
      "click": function($event) {
        _vm.showEmails = !_vm.showEmails
      }
    }
  }, [(!_vm.showEmails) ? _c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.L.localize('Label_View')))]) : _c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.L.localize('Label_Hide')))])]) : _vm._e()]), _vm._v(" "), (_vm.showEmails) ? _c('list', {
    staticClass: "view__embedded-content",
    attrs: {
      "data": _vm.entries,
      "fields": _vm.headers()
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-088ad82d!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/campaigns/form/CampaignTarget.vue
// module id = 701
// module chunks = 1